// ISO-3166 alpha-2 country code → emoji flag (regional-indicator pair). Returns '' for anything
// that isn't a clean 2-letter code so callers can render it unconditionally.
export function flag(cc?: string | null): string {
  if (!cc) return ''
  const c = cc.trim().toUpperCase().slice(0, 2)
  if (!/^[A-Z]{2}$/.test(c)) return ''
  return String.fromCodePoint(...[...c].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65))
}

// A UN/LOCODE's first two letters ARE its ISO country code (e.g. CNSHA → CN → 🇨🇳).
export const flagFromUnlocode = (code?: string | null): string => flag(code?.slice(0, 2))
